<template>
  <div class="tagsmanage-container">
    <star-condition-layout
      :onSearch="handleSearch"
      :onReset="reset"
      :loading="loading"
      ref="condition"
    >
      <star-condition-cell label="标签名称">
        <a-input v-model="search.spiderTagName" placeholder="请输入关键字" />
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-wrap">
      <TableHeadIcons :onRefresh="getTableList" :size.sync="tableDensity" :columns="columns">
        <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      </TableHeadIcons>

      <a-table
        :loading="loading"
        :size="tableDensity"
        :pagination="false"
        @change="handleTableChange"
        :columns="showColumns"
        :dataSource="roots"
        rowKey="spiderTagId"
      >
        <div slot="action" slot-scope="text, record">
          <a href="javascript:;" @click="handleEdit(record)"> <a-icon type="edit" /> 修改 </a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定要删除吗?" @confirm="() => handleDelete(record)">
            <a href="javascript:;"> <a-icon type="delete" />删除 </a>
          </a-popconfirm>
        </div>
      </a-table>
      <div  style="height: 46px" >
      </div>


    </div>

    <a-drawer
      :title="createAndUpdateData == null ? '新增标签' : '修改标签'"
      width="600"
      :closable="true"
      :visible="createAndUpdateShow"
      @close="createAndUpdateShow = false"
    >
      <TagForm
        ref="form"
        v-if="createAndUpdateShow"
        @refresh="handleRefresh"
        :formModel="createAndUpdateData"
        :roots="roots"
      />
    </a-drawer>
  </div>
</template>

<script>
import TagForm from './TagForm'
import { searchTagsListApi, deleteTagApi } from '@/api/System/Tags'

export default {
  components: { TagForm },

  data() {
    return {
      tableDensity: 'middle',
      loading: false,
      search: {
        spiderTagName: undefined
      },
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      roots: [],
      columns: [
        {
          width: 100,
          align: 'center',
          title: '',
          show: true
        },
        {
          title: '标签名称',
          show: true,
          dataIndex: 'spiderTagName'
        },
        {
          title: '操作',
          width: 160,
          show: true,
          scopedSlots: { customRender: 'action' }
        }
      ],

      createAndUpdateData: null,
      createAndUpdateShow: false
    }
  },

  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },

  created() {
    this.getTableList()
  },

  methods: {
    reset() {
      this.search.spiderTagName = undefined;
      this.handleSearch();
    },

    handleSearch() {
      this.pagination.current = 1
      this.getTableList()
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.getTableList()
    },

    async getTableList() {
      this.loading = true

      let query = {
        // pn: this.pagination.current,
        // pageSize: this.pagination.pageSize,
        ...this.search
      }

      const res = await searchTagsListApi(query)

      this.loading = false
      let { code, msg, data, extra } = res
      if (code === 200) {
        this.roots = data
          .filter((d) => d.parentId === -1)
          .map((d) => ({
            ...d,
            children: []
          }))

        data.forEach((d) => {
          const root = this.roots.find((r) => r.spiderTagId === d.parentId)
          if (root) {
            root.children.push(d)
          }
        })

        this.pagination.total = extra.page.pageCount || 0
      } else {
        this.$message.error(msg)
      }
    },

    handleAdd() {
      this.createAndUpdateData = null
      this.createAndUpdateShow = true
    },

    handleUpdate(record) {
      this.createAndUpdateData = {
        ...record
      }
      this.createAndUpdateShow = true
    },

    handleRefresh(toPn1 = false) {
      if (toPn1) {
        this.pagination.current = 1
      }
      this.createAndUpdateShow = false
      this.getTableList()
    },

    handleEdit(record) {
      this.createAndUpdateData = { ...record }
      this.createAndUpdateShow = true
    },

    async handleDelete(record) {
      const res = await deleteTagApi(record.spiderTagId)
      let { code, msg } = res
      if (code === 200) {
        this.getTableList()
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.tagsmanage-container {
  padding: 16px;
  .search {
    padding: 20px 20px 0 20px;
    background: #fff;
    margin-bottom: 20px;
  }
  .table-wrap {
    margin-top: 16px;
    background: #fff;
    padding: 0 20px 0 20px;
  }
}
</style>
